import {useMemo, useState} from 'react';

export default function (initItemPerPage) {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [itemPerPage, setItemPerPage] = useState(initItemPerPage || 10);
    const totalPage = useMemo(() => {
        return Math.ceil(totalRecords / itemPerPage);
    }, [totalRecords, itemPerPage]);
    return {
        currentPage,
        setCurrentPage,
        itemPerPage,
        setItemPerPage,
        totalRecords,
        setTotalRecords,
        totalPage: totalPage || 1
    }
}